/* global google $ */
import(/* webpackChunkName: "slick" */ '../components/slick');
class Location
{
    constructor () 
    {
        this.initReadMore();
        this.loadNearbyLocations();
        console.log("Location Page Initialized");
    }

    initReadMore() {
        if ($(window).innerWidth() > 1199) {
            if ($('.location-description').length) {
                let mapHeight = $("#map").outerHeight();
                import ('readmore-js').then(() =>{
                    $( ".location-description" ).each(function() {
                        if ($(this).height() > mapHeight) {
                            $(this).readmore({
                                speed: 100,
                                heightMargin: 16,
                                collapsedHeight: mapHeight - 110,
                                moreLink: '<a class="d-flex align-items-center justify-content-between w-100 border-top border-bottom border-gray-800 ff-agbook text-primary text-decoration-none py-2 mt-3" href="#">Read more <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMC1jMDAwIDc5LjE3MWMyN2ZhYiwgMjAyMi8wOC8xNi0yMjozNTo0MSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDI0LjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjNCNTE2NzhEQzRBMTFFREFDNzZGMjdDOUYxOTdDNkUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjNCNTE2NzlEQzRBMTFFREFDNzZGMjdDOUYxOTdDNkUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4Mjk2RDVGRkRDNDkxMUVEQUM3NkYyN0M5RjE5N0M2RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4Mjk2RDYwMERDNDkxMUVEQUM3NkYyN0M5RjE5N0M2RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pq2RcdsAAAJuSURBVHja7JjLTQNBDIbHk7lRAwVACQiOOXGiIeqgEU4IwQlKiEQBdMAFKTETaSONBj9+70MQKStZIWR29vNjbY/pM92nY7tyOsLrBH2CPkH/g6vMtA8F1vJfQdOMCvLS0LSAtykKXxaApZEhAcPnmYCpkXWV7yrb4XPd/T75eXnCBhrIZZXV8Pdq+I7cB4OX4I0ErCUFUgoVMkKItFApIDCNXCPFq6cAe+AlCKP9hlq6hdAUIA+8gMAUAPXCIzkKsAdeAsAUsO7YlNkCq+AlAIzCS3tlw/1h8DIBGFGiT3EMQLrgBXBrC7MvFBeOpa+7PW6EB3P3uanyJIDLUPVgS4CVD/LVFI45r331PBtAW5EUdItLH6NLAPf7ktezoIeAA/x2IehtoDcRU54WGnu5G2LayhxXVW6b/z9Weetc3rt9Y3SHv17IEsyrz1VeBGV6JVvo9yoPQpy2sjM4oDJuxbblBaShkiA4eprJQGh4JZmavbJRXHKgzJNVC3KgJSXD8hks5RnwnssTObmg4UEBha0Ka4YHAdXQalU9S3nrKPBss4yj/QgZ1kOVhzo7LTzmai+XGviQBO0d3dG5xEdTObfD9zkmT27vIR2FJBdKD3qtct7da0ky9lMPtuwMWMhQCGnsWamGFhhb+xXQbeQAstPks2H1pFg9NPewyiop84ldkz41F7c9BgMeUD1RwLRjhQw34KQozE7cMngPow0TMvlhI2VZVmVjTXgs5kEg74AUHlFIdyxmhciUi8EXEk6HJfhgz7IMvIweeBobHshwMDmzCm1cYMV2QhQowOAEKSJWBU1GLvZSnphxfgQYAO+3CP78IhomAAAAAElFTkSuQmCC"></a>',
                                lessLink: '<a class="d-flex align-items-center justify-content-between w-100 border-top border-bottom border-gray-800 ff-agbook text-primary text-decoration-none py-2 mt-3" href="#">Read less <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMC1jMDAwIDc5LjE3MWMyN2ZhYiwgMjAyMi8wOC8xNi0yMjozNTo0MSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDI0LjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjNCNTE2N0NEQzRBMTFFREFDNzZGMjdDOUYxOTdDNkUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjNCNTE2N0REQzRBMTFFREFDNzZGMjdDOUYxOTdDNkUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyM0I1MTY3QURDNEExMUVEQUM3NkYyN0M5RjE5N0M2RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyM0I1MTY3QkRDNEExMUVEQUM3NkYyN0M5RjE5N0M2RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhtgRzwAAAHsSURBVHja7JhBTsQwDEXjkg0LbsGGw3ACxEmQ2DHn4TCcAeYOLD5BQijNJPZ30o5UKZWsaWeSzLPrb6eVz/AajnYs4YDHhJ7QE3pCT+gJPaEPCx03Xk+M33FNaLmSU5RzcXDxUWdArgsNWgYge6IoTidQQnuAxHEXQMyFMSefi2hASAe8kPAarDZHYiewdOS0ECkjlfRBjxDz85dkj8ludii/78neGlGHBS3K+XOy+516xl2yUwN2Bb44gLes19rdtRioNp4vdt4R+swGJxJRzq+fkj0ku/27XayIoQjwd+x3sg9CjKuSp0U59/5LiUhPc0H2iQxQrdeRzF9pOBFIB6BEuYSsCXD13ULms+WYFNa6Y+JwVtgNE7NQDdSzNZUicjBq80W0oyPK0ohcT0ksRay182pH9G6UxJHbWg7DyH1pCXExxMbu/mSnsVXxb/mMKBuNcT3YYvBZDhuNMet6JEUiyh/XaikDgcI05y52eSDE43m6sJpLCR2Ua6pO1zqSp5Zqqm8BarDlOPoVAhyAVopAiXYVUIu0VjOt/YGmByZF2PT5/90rxFaDgDPSLDj13sMS4gjwKHgVGqTwRoBZcHjqNBwVwxKfVRphVItm5L3pEQhBCpOXTmDzvYclxKCUO6ZVg4x4c86PAAMA/fjSD2EMPFUAAAAASUVORK5CYII="></a>',
                            });
                        }
                    });
                });
            }
        }
    }

    loadNearbyLocations() /* calculates and puts the distance of a location from a given postcode on location search */
    {
        var _this = this;
        const latlongs = $('#nearby-location').data('latlongs').split('|');
        let currlatlong = $('#nearby-location').data('latlong');
        
        const postcodes = $('#nearby-location').data('postcodes').split(', ');
        let postcode = $('#nearby-location').data('currpostcode');
        var locationId = $('#nearby-location').data('location');
        if(currlatlong != "" && latlongs.length == postcodes.length)
        {
            _this.loadLocationsByDistanceFromLatlongNew(locationId);
        }  
        else{
            _this.loadLocationsByDistanceFromPostcode(postcodes, postcode);
        }  
    }

    loadLocationsByDistanceFromPostcode(postcodes, postcode)
    {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': postcode }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var inputLatitude = results[0].geometry.location.lat();
                var inputLongitude = results[0].geometry.location.lng();
                //var inputLatlng = new google.maps.LatLng(inputLatitude, inputLongitude);
            }

            let distanceArr = [];
            for(let i in postcodes){
                const loc = postcodes[i].split(':');
                let key = loc[0];
                let postcode = loc[1];
                console.log(key + ' -> ' + postcode);
                geocoder.geocode({ 'address': postcode }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var latitude = results[0].geometry.location.lat();
                        var longitude = results[0].geometry.location.lng();
                    }
                
                    //var p2 = new google.maps.LatLng(latitude, longitude);
                    //let distance = (google.maps.geometry.spherical.computeDistanceBetween(inputLatlng, p2) * 0.000621371).toFixed(2);
                    //_this.getDrivingDistance(inputLatitude,inputLongitude,latitude,longitude,key,distanceArr);
                    $.ajax({
                        type: 'get',
                        url: '/getDrivingDistance',
                        dataType: 'json',
                        data: {lat1: inputLatitude, lng1: inputLongitude, lat2: latitude, lng2: longitude},
                        processData: true,
                        success: function(response){
                            distanceArr.push({ 'key': key, 'distance': response.distance });
                            console.log(distanceArr.length);
                            if(distanceArr.length == postcodes.length)
                            {
                                distanceArr.sort(function(a, b){return a.distance - b.distance});
                                $.ajax({
                                    type: 'get',
                                    url: '/getLocationByDistance',
                                    dataType: 'json',
                                    data: {distanceArr: distanceArr, type: 'location'},
                                    processData: true,
                                    success: function(response){
                                        $('#nearby-location').html(response.locationHtml);
                                        if($('.nearby-location-carousal').length) {
                                            $('.nearby-location-carousal').slick({
                                                slidesToShow: 3,
                                                slidesToScroll: 1,
                                                arrows: true,
                                                fade: false,
                                                rows: 0,
                                                infinite: false,
                                                responsive: [
                                                    {
                                                        breakpoint: 1199,
                                                        settings: {
                                                            slidesToShow: 2
                                                        }
                                                    },
                                                    {
                                                        breakpoint: 767,
                                                        settings: {
                                                            slidesToShow: 1
                                                        }
                                                    }
                                                ]
                                            });
                                        }
                                    },
                                    error: function(){
                                        alert("Something went rong");
                                    }
                                });
                            }
                        },
                        error: function(){
                            alert('no distance available');
                        }
                    });
                    
                });
            }
            
        }); 
    }

    loadLocationsByDistanceFromLatlong(latlongs, currlatlong)
    {
        let currentlatlong = currlatlong.split(',');
        var latitude = currentlatlong[0];
        var longitude = currentlatlong[1];
        let distanceArr = [];
        for(let i in latlongs){
            const loc = latlongs[i].split(':');
            let key = loc[0];
            let latlong = loc[1].split(',');
            var inputLatitude = latlong[0];
            var inputLongitude = latlong[1];
            $.ajax({
                type: 'get',
                url: '/getDrivingDistance',
                dataType: 'json',
                data: {lat1: inputLatitude, lng1: inputLongitude, lat2: latitude, lng2: longitude},
                processData: true,
                success: function(response){
                    distanceArr.push({ 'key': key, 'distance': response.distance });
                    console.log(distanceArr.length);
                    if(distanceArr.length == latlongs.length)
                    {
                        distanceArr.sort(function(a, b){return a.distance - b.distance});
                        $.ajax({
                            type: 'get',
                            url: '/getLocationByDistance',
                            dataType: 'json',
                            data: {distanceArr: distanceArr, type: 'location'},
                            processData: true,
                            success: function(response){
                                $('#nearby-location').html(response.locationHtml);
                                if($('.nearby-location-carousal').length) {
                                    $('.nearby-location-carousal').slick({
                                        slidesToShow: 3,
                                        slidesToScroll: 1,
                                        arrows: true,
                                        fade: false,
                                        rows: 0,
                                        infinite: false,
                                        responsive: [
                                            {
                                                breakpoint: 1199,
                                                settings: {
                                                    slidesToShow: 2
                                                }
                                            },
                                            {
                                                breakpoint: 767,
                                                settings: {
                                                    slidesToShow: 1
                                                }
                                            }
                                        ]
                                    });
                                }
                            },
                            error: function(){
                                alert("Something went rong");
                            }
                        });
                    }
                },
                error: function(){
                    alert('no distance available');
                }
            });
        }
    }

    loadLocationsByDistanceFromLatlongNew(locationId)
    {
        $.ajax({
            type: 'get',
            url: '/getLocationByDistance',
            dataType: 'json',
            data: {locationId: locationId, type: 'location'},
            processData: true,
            success: function(response){
                $('#nearby-location').html(response.locationHtml);
                if($('.nearby-location-carousal').length) {
                    $('.nearby-location-carousal').slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: true,
                        fade: false,
                        rows: 0,
                        infinite: false,
                        responsive: [
                            {
                                breakpoint: 1199,
                                settings: {
                                    slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                }
            },
            error: function(){
                alert("Something went rong");
            }
        });            
    }
}

new Location
